import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar-inner noselect" }
const _hoisted_2 = { class: "sidebar sidebar--left" }
const _hoisted_3 = { class: "sidebar__section" }
const _hoisted_4 = { class: "sidebar__field" }
const _hoisted_5 = { class: "sidebar__section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_autocomplete_single_select = _resolveComponent("dropdown-autocomplete-single-select")!
  const _component_proposal_field_value = _resolveComponent("proposal-field-value")!
  const _component_team_section_item = _resolveComponent("team-section-item")!

  return (_openBlock(), _createElementBlock("nav", {
    class: "sidebar",
    style: _normalizeStyle(_ctx.navBarStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", _hoisted_2, [
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"sidebar__back-container\" data-v-7a2c8388><a href=\"#\" class=\"sidebar__back-link\" data-v-7a2c8388><span class=\"sidebar__back-icon\" data-v-7a2c8388><svg xmlns=\"http://www.w3.org/2000/svg\" height=\"20px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#fff\" data-v-7a2c8388><path d=\"M760-200v-160q0-50-35-85t-85-35H273l144 144-57 56-240-240 240-240 57 56-144 144h367q83 0 141.5 58.5T840-360v160h-80Z\" data-v-7a2c8388></path></svg></span> BACK TO DESIGNING SQUAD </a></div><div class=\"sidebar__customer\" data-v-7a2c8388>CUSTOMER</div><div class=\"sidebar__company\" data-v-7a2c8388><h1 class=\"sidebar__company-name\" data-v-7a2c8388>ORBIS CORP</h1><svg class=\"sidebar__company-icon\" xmlns=\"http://www.w3.org/2000/svg\" height=\"20px\" viewBox=\"0 -960 960 960\" width=\"24px\" fill=\"#fff\" data-v-7a2c8388><path d=\"m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z\" data-v-7a2c8388></path></svg></div><button class=\"sidebar__button sidebar__button--yellow\" data-v-7a2c8388> ok | no hold </button>", 4)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "workflow" }, [
              _createElementVNode("label", { class: "sidebar__label" }, "WORKFLOW")
            ], -1)),
            _createVNode(_component_dropdown_autocomplete_single_select, {
              modelValue: _ctx.selectedSingleOption,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSingleOption) = $event)),
              label: "ATTENTION REASON",
              "search-by": "string",
              data: [1, 2, 3],
              "is-new-ui": true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_dropdown_autocomplete_single_select, {
              modelValue: _ctx.selectedSingleOption,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSingleOption) = $event)),
              label: "ACTION REQUIRED BY",
              "search-by": "string",
              data: [1, 2, 3],
              "is-new-ui": true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_dropdown_autocomplete_single_select, {
              modelValue: _ctx.selectedSingleOption,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSingleOption) = $event)),
              label: "PROPOSAL HOLD",
              "search-by": "string",
              data: [1, 2, 3],
              "is-new-ui": true
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dummyProposalFieldData, (item) => {
          return (_openBlock(), _createBlock(_component_proposal_field_value, {
            key: item.label,
            item: item
          }, null, 8, ["item"]))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dummyTeamMembers, (item) => {
            return (_openBlock(), _createBlock(_component_team_section_item, {
              key: item.role,
              teamMember: item
            }, null, 8, ["teamMember"]))
          }), 128))
        ])
      ])
    ])
  ], 4))
}